import apiService from '@/services/api.service';

export default {
    async syncContact(): Promise<boolean> {
        const { status } = await apiService.post('chatbase/sync-contact');

        return status === 200;
    },

    async getUserHash(): Promise<string> {
        const { data } = await apiService.get('chatbase/user-hash');

        return data.hash;
    },
};
